/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const RangeMaskIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Range Mask',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M25.949 22.088a10.9 10.9 0 0 1-.846 3.279l1.776 1.026A12.944 12.944 0 0 0 28 22.088ZM21.669 29.747l1.031 1.781a13.088 13.088 0 0 0 3.126-3.228l-1.782-1.028a11.062 11.062 0 0 1-2.375 2.475ZM16.451 31.9v2.07a12.928 12.928 0 0 0 4.389-1.307l-1.024-1.773a10.907 10.907 0 0 1-3.365 1.01ZM10.754 31.157l-1.027 1.78a12.981 12.981 0 0 0 4.548 1.081v-2.045a10.927 10.927 0 0 1-3.521-.816ZM6.18 27.558 4.392 28.59a13.111 13.111 0 0 0 3.424 3.31l1.024-1.778a11.076 11.076 0 0 1-2.66-2.564ZM4.058 22.088H2a12.947 12.947 0 0 0 1.279 4.632l1.782-1.028a10.908 10.908 0 0 1-1.003-3.604ZM5.068 16.313 3.279 15.28A12.947 12.947 0 0 0 2 19.912h2.059a10.928 10.928 0 0 1 1.009-3.599ZM8.848 11.893l-1.032-1.788a13.111 13.111 0 0 0-3.424 3.305l1.8 1.038a11.085 11.085 0 0 1 2.656-2.555ZM14.275 10.047V7.982a12.959 12.959 0 0 0-4.548 1.081l1.037 1.8a10.943 10.943 0 0 1 3.511-.816ZM35.823 4.258a3.238 3.238 0 0 0-.913-2.618l-.525-.525A3.206 3.206 0 0 0 32.1.187h-.121a3.734 3.734 0 0 0-2.5 1.108L25.95 4.822l-1.313-1.313A.89.89 0 0 0 24 3.251a1.037 1.037 0 0 0-.728.308l-2.36 2.362a.966.966 0 0 0-.051 1.363l.766.766-11.3 11.3a4.471 4.471 0 0 0 6.323 6.323l11.3-11.3.79.791a.894.894 0 0 0 .636.257 1.033 1.033 0 0 0 .728-.308l2.362-2.361a.967.967 0 0 0 .05-1.364L31.2 10.075l3.525-3.526a3.749 3.749 0 0 0 1.098-2.291Zm-20.591 20a2.471 2.471 0 1 1-3.494-3.494l11.3-11.3 3.5 3.495Z"
    />
  </svg>`;
};
